import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { NotificationProvider, NotificationToast } from "@hm-group/bads-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <NotificationProvider>
        <NotificationToast />
        <App />
      </NotificationProvider>
    </MsalProvider>
  </React.StrictMode>
);
